import { render, staticRenderFns } from "./realtime_data.vue?vue&type=template&id=e7024da4&scoped=true&"
import script from "./realtime_data.vue?vue&type=script&lang=js&"
export * from "./realtime_data.vue?vue&type=script&lang=js&"
import style0 from "./realtime_data.vue?vue&type=style&index=0&id=e7024da4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7024da4",
  null
  
)

export default component.exports